import ba from "./ba.png"
import ca from "./cag.png"
import at from "./at.png"

import person from "./person.png"
import screen from "./screen.png"

// import gameController from "./statsBanner/gameController.png"
// import globe from "./statsBanner/globe.png"
// import handshake from "./statsBanner/handshake.png"
// import user from "./statsBanner/user.png"
import bannerArt from "./statsBanner/bannerArt.png"


// brandsSlides
// images
import image1 from "./brands/1.png"
import image2 from "./brands/2.png"
import image3 from "./brands/3.png"
import image4 from "./brands/4.png"
import image5 from "./brands/5.png"
import image6 from "./brands/6.png"
import image7 from "./brands/7.png"
import image8 from "./brands/8.png"
import image9 from "./brands/9.png"




// import treeImage from "./tree.png"

// import treeImageMobile from "./steps.png"
// import curvedProcessMobile from "./mobileCurvedProcess.png"
import brandBannerMobile from "./mobileBrands.png"

import brandsBanner from "./clientsBanner/brands2.png"

import curvedProcess from "./curvedProcess.png"

// import clientsReturns from "./clientsReturns.png"
// import clientsReturnsMobile from "./clientsReturnsMobile.png"

import upperFooterArt from "./upperFooterArt.png"

import bannerArt2 from "./statsBanner/bannerArt2.png"


// Slider Assets
import img1 from "./Slider/image1.png"
import img2 from "./Slider/image2.png"
import img3 from "./Slider/image3.png"

import testimonialAvatar1 from "./testimonial/1.png"
import testimonialAvatar2 from "./testimonial/2.png"
import testimonialAvatar3 from "./testimonial/3.png"
import testimonialAvatar4 from "./testimonial/4.png"
import testimonialAvatar5 from "./testimonial/5.png"

// import backwardLine from "./stepper/backwardLine.png"
// import forwardLine from "./stepper/forwardLine.png"
import step from "./stepper/step.png"

import customTestimonialAssets from "./customTestimonial/index"

// import testimonial1 from "./testimonialsSlider/1.png"
// import testimonial2 from "./testimonialsSlider/2.png"
// import testimonial3 from "./testimonialsSlider/3.png"

const homePageAssets = {
    assessments: { ba, ca, at },
    person,
    screen,
    stats: {
        // gameController,
        // globe,
        // handshake,
        // user,
        bannerArt
    },
    brandSlides: {
        image1,
        image2,
        image3,
        image4,
        image5,
        image6,
        image7,
        image8,
        image9
    },
    // treeImage,
    // treeImageMobile,
    // curvedProcessMobile,
    brandBannerMobile,
    brandsBanner,
    curvedProcess,
    // clientsReturns,
    // clientsReturnsMobile,
    upperFooterArt,
    bannerArt2,
    sliderAssets: { img1, img2, img3 },
    testimonialsAvatars: {
        testimonialAvatar1,
        testimonialAvatar2,
        testimonialAvatar3,
        testimonialAvatar4,
        testimonialAvatar5,
    },
    stepperAssets: {
        // backwardLine,
        // forwardLine,
        step
    },
    customTestimonialAssets,
    // testimonialsSliderAssets:{testimonial1,testimonial2,testimonial3}

}

export default homePageAssets